<template>
  <div class="room-audio" data-grm-comp="RoomCallAudio">
      <audio autoplay
          ref="audios"
          v-for="audioData in audioStreams"
          :key="audioData.track.id"
          :data-user-id="audioData.userId"
          :data-track-id="audioData.stream.getAudioTracks()[0]?.id"
      ></audio>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
    name: "RoomCallAudio",
    data () {
        return {
            audioStreamById: {},
            audioStreams: []
        }
    },
    watch: {
        'isSpeakerOff': {
            immediate: true,
            handler(off) {
                if(!this.$refs.audios) return;
                this.$refs.audios.forEach(audio => {
                    audio.muted = off;
                });
            }
        },
        'getSpeakerDeviceId': {
            immediate: true,
            handler(deviceId) {
                this.setSinkId({deviceId})
            }
        },
        userGestureInit(){
            this.$refs.audios.forEach(audio => {
              audio.muted = this.isSpeakerOff;
            })
        },
    },
    created () {
        this.$roomApi.addEventListeners((this._Events = _Events()), this);
    },
    computed: {
        ...mapGetters('room', ['deviceSettings']),
        ...mapGetters('user', [
            'me',
        ]),
        ...mapGetters('call', [
            'userGestureInit',
        ]),
        isSpeakerOff(){
            return this.me.speakerStatus !== 'on';
        },
        getSpeakerDeviceId () {
            return this.deviceSettings.audiooutput?.deviceId;
        }
    },
    methods: {
        ...mapMutations('call',[
            'REQUEST_UNMUTE',
            'SET_USER_GESTURE_INIT',
        ]),
        addTrack ({userId, track}) {
            if(!track) return;
            if(this.audioStreamById[track.id]){
                console.warn('audio track existed :', userId, track);
                return;
            }

            track.addEventListener('ended', e => {
                const track = e.target;
                this.removeTrack({track});
            });

            const stream = new MediaStream([track]);
            const audioData = {
                userId, track, stream
            };

            this.audioStreamById[track.id] = audioData;
            this.audioStreams.push(audioData);

            const idx = this.audioStreams.length - 1;
            this.$nextTick(() => {
              const audio = this.$refs.audios[idx];
              audio.srcObject = stream;
              audio.muted = this.isSpeakerOff;
              audio.play().catch(e => {
                setTimeout(() => {
                  audio.play().catch(e => {
                    if (e.message.includes('didn\'t interact')) { // 자동 재생 문제
                      audio.muted = true;
                      this.REQUEST_UNMUTE({
                        callback: () => {
                          this.$alert({
                            text: this.$t('call.mixing.confirmAudio'),
                            onlyOk: true,
                            ok: () => {
                              this.SET_USER_GESTURE_INIT();
                              audio.play();
                            },
                          })
                        }
                      });
                    } else {
                      console.error('audio play error :', userId, track);
                    }
                  }, 500)
                });
                this.setSinkId({audio});
              });
            })
        },
        removeTrack ({userId, track}) {
            if(!track && !userId){
                return;
            }
            const audioData = track
                ? this.audioStreamById[track.id]
                : this.audioStreams.find(ad => ad.userId===userId);
            if(!audioData) return;

            track = audioData.track;
            delete this.audioStreamById[track.id];
            const idx = this.audioStreams.findIndex(ad => ad===audioData);
            if(idx > -1){
                this.audioStreams.splice(idx, 1);
            }
        },
        setSinkId ({deviceId, audio}) {
            if(!HTMLAudioElement.prototype.setSinkId){
                // not supported
                return;
            }
            deviceId = deviceId || this.getSpeakerDeviceId;
            if(!deviceId) return;
            if(deviceId === 'default'){
                deviceId = '';
            }

            if(!audio && !this.$refs.audios) return;
            (audio ? [audio] : this.$refs.audios)
            .forEach(audio => {
                audio.setSinkId
                  && audio.sinkId !== deviceId
                  && audio.setSinkId(deviceId);
            });
        }
    }
}

function _Events() {
    return {
        room_call_addUserAudioTrack: function(e){
            this.addTrack(e.data);
        },
        room_user_leave: function(e) {
            this.removeTrack({userId: e.data.userId});
        },
        room_call_addAudioTrack: function(e) {
            this.addTrack(e.data);
        }
    }
}
</script>

<style lang="scss" scoped>
.room-audio {
  display: none;
}
</style>